import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";

export default function BrandGuide() {
  return (
    <Container className="py-5">
      <h1 className="mb-4">Brand Guide</h1>
      <Row className="g-4">
        <Col md={4}>
          <Card
            className="text-white"
            style={{
              background: "linear-gradient(141deg, #ffc60b -15%, #f16d09 32%)",
            }}
          >
            <Card.Body>
              <Card.Title>Hero Gradient (Floret)</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="text-white"
            style={{ background: "linear-gradient(141deg, #ffc60b, #fcED21)" }}
          >
            <Card.Body>
              <Card.Title>Secondary Gradient (Sunshine)</Card.Title>
            </Card.Body>
          </Card>
        </Col>
        <Col md={4}>
          <Card
            className="text-white"
            style={{ background: "linear-gradient(141deg, #492c28, #2e1719)" }}
          >
            <Card.Body>
              <Card.Title>Secondary Gradient (Hull)</Card.Title>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
}
